import React from "react";
import Footer from "./Footer";
import NavBar from "./NavBar";
import { useMediaQuery, useTheme } from "@mui/material";

const TrustRegistration = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md")); // Mobile breakpoint at 900px

  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f5f5f5",
        margin: 0,
        padding: 0,
      }}
    >
      <NavBar />

      {/* Header */}
      <div
        style={{
          backgroundColor: "#00b050",
          color: "white",
          padding: isMobile ? "15px" : "30px",
          fontSize: isMobile ? "20px" : "28px",
          fontWeight: "bold",
          textAlign: "center",
          marginTop: "65px",
        }}
      >
        Trust Registration
      </div>

      {/* Intro Paragraph */}
      <p
        style={{
          maxWidth: isMobile ? "100%" : "1200px",
          width: "95%",
          margin: isMobile ? "10px auto" : "20px auto",
          padding: isMobile ? "10px" : "20px",
          fontSize: isMobile ? "14px" : "16px",
        }}
      >
        A trust is established through a trust deed, offering two primary types:
        public trusts for the broader community’s benefit and private trusts for
        a specific group of beneficiaries. Registration enhances its legal
        standing and eligibility for government benefits.
      </p>

      {/* Content */}
      <div
        style={{
          maxWidth: isMobile ? "100%" : "1200px",
          width: "95%",
          margin: isMobile ? "10px auto" : "15px auto",
          padding: isMobile ? "10px" : "20px",
        }}
      >
        <div
          style={{
            background: "white",
            padding: isMobile ? "15px" : "25px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            lineHeight: "1.6",
            color: "#333",
          }}
        >
          {/* Overview of Trusts */}
          <div>
            <h2
              style={{
                color: "#001F3F",
                fontWeight: 600,
                marginBottom: isMobile ? "4px" : "6px",
                fontFamily: "Times New Roman, Georgia, serif",
                fontSize: isMobile ? "18px" : "24px",
              }}
            >
              Overview of Trusts
            </h2>
            <div
              style={{
                width: "80px",
                height: "3px",
                background: "#22c55e",
                borderRadius: "2px",
              }}
            ></div>
          </div>

          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Under the Indian Trust Act of 1882, a trust is a legal arrangement
            where a trustor transfers property to a trustee for the benefit of a
            beneficiary. This structure supports public charitable trusts, aiding
            community welfare, and private trusts, serving specific individuals
            or families, depending on the designated beneficiaries.
          </p>

          {/* Types of Trusts */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Types of Trusts
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <ul
            style={{
              paddingLeft: isMobile ? "15px" : "20px",
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            <li>
              <strong>Public Trust:</strong> Benefits the general public,
              including charitable and religious trusts.
            </li>
            <li>
              <strong>Private Trust:</strong> Serves a defined group, with
              subcategories based on identifiable or non-identifiable
              beneficiaries and their shares.
            </li>
          </ul>

          {/* Tax Benefits and Certifications */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Tax Benefits and Certifications
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Trusts can obtain a 12A certificate for lifelong income tax exemption
            on surplus funds. Additionally, an 80G certificate allows donors to
            claim deductions under the Income Tax Act, incentivizing
            contributions to certified NGOs or trusts.
          </p>

          {/* Legal Framework */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Legal Framework
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            The Indian Trusts Act, 1882, governs trusts nationwide, though states
            may enact their own laws. Public charitable trusts must register
            with the local charity commissioner, ensuring compliance with
            eligibility criteria like experience and performance for funding or
            projects.
          </p>

          {/* Registration Steps */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Registration Steps
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Registering a public charitable trust involves:
          </p>
          <ol
            style={{
              paddingLeft: isMobile ? "15px" : "20px",
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            <li>Select a unique name not restricted under the Emblems and Names Act, 1950.</li>
            <li>Appoint at least one settler (preferably a resident) and a minimum of two trustees.</li>
            <li>Draft a Trust Deed and Memorandum of Association (MOA) detailing rules, objectives, and member details.</li>
            <li>Submit identity proofs (e.g., Aadhaar, PAN), address proof, and a NOC from the property owner.</li>
            <li>Prepare the Trust Deed on stamp paper (value varies by state) and pay a Rs. 1100 fee.</li>
            <li>File the deed with the registrar, with the settler and two witnesses present, to receive a certified copy.</li>
            <li>Obtain the registration certificate within seven working days after verification.</li>
          </ol>

          {/* Essential Documentation */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Essential Documentation
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Required documents include the Trust Deed, self-attested identity
            proofs of the settler and trustees, PAN card, proof of the registered
            office address, and a signed non-objection letter from the landowner.
          </p>

          {/* Final Thoughts */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Final Thoughts
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Trust registration is a strategic choice for charitable or private
            purposes, offering tax benefits and legal recognition. Proper
            planning and adherence to registration requirements ensure a trust’s
            smooth operation and community impact.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TrustRegistration;